import { ReactElement } from 'react'
import styled, { css } from 'styled-components'
import { CheckCircle, CheckCircleOutline } from '@mui/icons-material'
import { I18n } from 'common'
import { defaultTheme } from '../../../../theme/index'

const VIN_LENGTH = 17

interface VinCheckMessageProps {
  vin: string
}

export const VinCheckMessage = (props: VinCheckMessageProps): ReactElement => {
  const { vin } = props

  const numChars = vin.length
  const { colors } = defaultTheme
  let textColor: string = numChars > 0 ? colors.red : colors.greyDark
  let Icon: ReactElement = <CheckCircleOutlineIcon $textColor={textColor} />

  if (numChars === VIN_LENGTH) {
    textColor = colors.success
    Icon = <CheckCircleIcon $textColor={textColor} />
  }

  return (
    <Wrapper>
      <Message>
        {Icon}
        <I18n
          name="vinMustContain17Characters"
          style={{ color: textColor, margin: '1px 0px 0px 0px' }}
        />
      </Message>
      <CharCounter $textColor={textColor}>
        {numChars}/{VIN_LENGTH}
      </CharCounter>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: 4px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  gap: 4px;
`

const Message = styled.div`
  display: flex;
  gap: 4px;
`

const BaseIcon = css<{ $textColor: string }>`
  color: ${(p) => p.$textColor};
  font-size: 1rem;
`
const CheckCircleOutlineIcon = styled(CheckCircleOutline)<{
  $textColor: string
}>`
  ${BaseIcon}
`

const CheckCircleIcon = styled(CheckCircle)<{ $textColor: string }>`
  ${BaseIcon}
`

const CharCounter = styled.span<{ $textColor: string }>`
  color: ${(p) => p.$textColor};
  margin: 1px 2px 0px 0px;
`
